import Vue from 'vue';
import Router from 'vue-router';
import recoverPassword from '@/components/User/recoverPassword/recoverChangePassword.vue';
Vue.use(Router);


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // / LOGIN
    // {
    //   path: '/login', 
    //   name: 'login',
    //   component: function () {
    //     return import('./views/Login/Login.vue');
    //   },
      
    // },
    // / HOME
    {
      path: '/', 
      name: 'home',
      component: function () {
        // return import('./views/Home/Home.vue');
        return import('./views/Config/Config.vue');
      },
      
    },
    // USERS ADMIN
    {
      path: '/users_admin',
      name: 'users',
      component: function () {
        return import('./views/User/User.vue');
      },
    },
    // OPENCALLS ADMIN
    {
      path: '/opencall_admin', // pendiente
      name: 'opencall',
      component: function () {
        return import('./views/OpenCall_admin/OpenCall.vue');
      },
    },
    // OPENCALLS LAST EDITION
    {
      path: '/opencall_oldEdition', // pendiente
      name: 'opencall',
      component: function () {
        return import('./views/OpenCall_oldEdition/OpenCall.vue');
      },
    },
    // OPENCALLS CONSEJO
    {
      path: '/opencall', // pendiente
      name: 'opencall',
      component: function () {
        return import('./views/OpenCall/OpenCall.vue');
      },
    },
    // CONFIG ADMIN
    {
      path: '/config_admin',
      name: 'opencall',
      component: function () {
        return import('./views/Config/Config.vue');
      },
    },
    {
      path: '/recoverPassword',
      name: 'recoverChangePassword',
      component: recoverPassword
    },

    // otherwise redirect to home //// 404 Not Found
    { path: '*', redirect: '/' }
  ]
});
